import { GET_API } from "../../Functionalities/APIs";
import { accountsAccountsUrl } from "../../Constants/apiUrls";
import { DAY_COMPLETED } from "../../Functionalities/dayBasis";
import { rupees } from "../Insights/format";

export const fetchOrderReportSummary = async (params) => {
  const result = await GET_API("", `${params}&summary=true`, accountsAccountsUrl);
  const body = result && result.data;
  return body && body.Status === true ? body.summary : null;
};

const isZero = (value) => !Number(value);

const amountTile = (label, value, hint, tone) => ({
  label,
  value: rupees(value),
  hint,
  tone: tone || (isZero(value) ? "zero" : undefined),
});

const cashHint = (summary, basis) => {
  if (!isZero(summary.cash_at_counter)) return `${rupees(summary.cash_at_counter)} paid at the counter`;
  return basis === DAY_COMPLETED ? undefined : "count by day completed to match Rider Salary";
};

const billTotalTile = (summary) => {
  if (!isZero(summary.unexplained)) {
    return amountTile("Bill Total", summary.bill_total, `${rupees(summary.unexplained)} does not add up`, "bad");
  }
  const delivered = Math.round((Number(summary.cash) + Number(summary.online)) * 100);
  const hint =
    delivered === Math.round(Number(summary.bill_total) * 100)
      ? "the parts above add up to this"
      : "cash and online count delivered orders only";
  return amountTile("Bill Total", summary.bill_total, hint);
};

export const orderReportTiles = (summary, basis) => {
  const waived = summary.delivery_charge_waived;
  return [
    { label: "Orders", value: String(summary.orders), tone: summary.orders ? undefined : "zero" },
    amountTile("Food Amount", summary.food_amount),
    amountTile("Cash", summary.cash, cashHint(summary, basis)),
    amountTile("Online", summary.online),
    amountTile("GST", summary.gst),
    amountTile("Restaurant Charge", summary.restaurant_charge),
    amountTile("Delivery Charge", summary.delivery_charge, isZero(waived) ? undefined : `${rupees(waived)} waived`),
    amountTile("Tip", summary.tip),
    amountTile("Surge", summary.surge),
    amountTile("Foodoor Cares", summary.foodoor_cares),
    ...(isZero(summary.coupon_discount) ? [] : [amountTile("Coupon Discount", summary.coupon_discount)]),
    ...(isZero(summary.round_off) ? [] : [amountTile("Round Off", summary.round_off)]),
    billTotalTile(summary),
  ];
};
